import { useEffect, useRef } from 'react';
import mapboxgl from 'mapbox-gl';
import { useUnit } from 'effector-react';
import {
  resetMapLoadedEv,
  setMapLoadedEv,
} from '../../models/mapModel/index.js';
import alta_railway from '../../assets/map_icons/alta_railway.png';
import bait from '../../assets/map_icons/bait.png';
import box_van from '../../assets/map_icons/box-van.png';
import camera from '../../assets/map_icons/camera.png';
import chemical_incident from '../../assets/map_icons/chemical-incident.png';
import clothes from '../../assets/map_icons/clothes.png';
import cog from '../../assets/map_icons/cog.png';
import dig from '../../assets/map_icons/dig.png';
import ferry_terminals from '../../assets/map_icons/ferry_terminals.png';
import hammer from '../../assets/map_icons/hammer.png';
import iz from '../../assets/map_icons/iz.png';
import kz_airports from '../../assets/map_icons/kz_airports.png';
import kz_helicopter from '../../assets/map_icons/kz_helicopter.png';
import lightbulb from '../../assets/map_icons/lightbulb.png';
import minres from '../../assets/map_icons/minres.png';
import pharmaceuticals from '../../assets/map_icons/pharmaceuticals.png';
import sez from '../../assets/map_icons/sez.png';
import telecom from '../../assets/map_icons/telecom.png';
import transmission_power from '../../assets/map_icons/transmission-power.png';
import azs from '../../assets/map_icons/azs.png';
import sto from '../../assets/map_icons/sto.png';
import warehouse from '../../assets/map_icons/warehouse.png';

mapboxgl.accessToken =
  'pk.eyJ1IjoiZnJvbnRpZXJkIiwiYSI6ImNrYTNuMjBvNjAxNnAzbW85N3ZsbmRvZmYifQ.9OWZ7YWGJ4DDIV4bCTwsaA';

function Map() {
  const mapContainer = useRef(null);
  const mapRef = useRef(null);
  const setMapLoaded = useUnit(setMapLoadedEv);
  const resetMapLoaded = useUnit(resetMapLoadedEv);

  useEffect(() => {
    if (mapRef.current) return;
    window.map = new mapboxgl.Map({
      container: mapContainer.current,
      // style: 'mapbox://styles/mapbox/streets-v12',
      style: 'mapbox://styles/mapbox/dark-v11',
      center: [65.7133351434909, 46.271747202152454],
      zoom: 4,
      minZoom: 4,
      projection: 'mercator',
    });
    mapRef.current = window.map;
    window.map.dragRotate.disable();

    window.map.on('style.load', () => {
      window.map.loadImage(alta_railway, (error, image) => {
        if (error) throw error;
        window.map.addImage('alta_railway', image);
      });
      window.map.loadImage(bait, (error, image) => {
        if (error) throw error;
        window.map.addImage('bait', image);
      });
      window.map.loadImage(box_van, (error, image) => {
        if (error) throw error;
        window.map.addImage('box_van', image);
      });
      window.map.loadImage(camera, (error, image) => {
        if (error) throw error;
        window.map.addImage('camera', image);
      });
      window.map.loadImage(chemical_incident, (error, image) => {
        if (error) throw error;
        window.map.addImage('chemical_incident', image);
      });
      window.map.loadImage(clothes, (error, image) => {
        if (error) throw error;
        window.map.addImage('clothes', image);
      });
      window.map.loadImage(cog, (error, image) => {
        if (error) throw error;
        window.map.addImage('cog', image);
      });
      window.map.loadImage(dig, (error, image) => {
        if (error) throw error;
        window.map.addImage('dig', image);
      });
      window.map.loadImage(ferry_terminals, (error, image) => {
        if (error) throw error;
        window.map.addImage('ferry_terminals', image);
      });
      window.map.loadImage(hammer, (error, image) => {
        if (error) throw error;
        window.map.addImage('hammer', image);
      });
      window.map.loadImage(iz, (error, image) => {
        if (error) throw error;
        window.map.addImage('iz', image);
      });
      window.map.loadImage(kz_airports, (error, image) => {
        if (error) throw error;
        window.map.addImage('kz_airports', image);
      });
      window.map.loadImage(kz_helicopter, (error, image) => {
        if (error) throw error;
        window.map.addImage('kz_helicopter', image);
      });
      window.map.loadImage(lightbulb, (error, image) => {
        if (error) throw error;
        window.map.addImage('lightbulb', image);
      });
      window.map.loadImage(minres, (error, image) => {
        if (error) throw error;
        window.map.addImage('minres', image);
      });
      window.map.loadImage(pharmaceuticals, (error, image) => {
        if (error) throw error;
        window.map.addImage('pharmaceuticals', image);
      });
      window.map.loadImage(sez, (error, image) => {
        if (error) throw error;
        window.map.addImage('sez', image);
      });
      window.map.loadImage(telecom, (error, image) => {
        if (error) throw error;
        window.map.addImage('telecom', image);
      });
      window.map.loadImage(transmission_power, (error, image) => {
        if (error) throw error;
        window.map.addImage('transmission_power', image);
      });
      window.map.loadImage(azs, (error, image) => {
        if (error) throw error;
        window.map.addImage('azs', image);
      });
      window.map.loadImage(sto, (error, image) => {
        if (error) throw error;
        window.map.addImage('sto', image);
      });
      window.map.loadImage(warehouse, (error, image) => {
        if (error) throw error;
        window.map.addImage('warehouse', image);
      });
      setMapLoaded(true);
    });

    return () => {
      resetMapLoaded();
      delete window.map;
      mapRef.current?.remove();
      mapRef.current = null;
    };
  }, []);

  // FIXME Part that adds draw polygon functionality. Maybe usefull later
  // useEffect(() => {
  //   if (mapLoaded && Object.keys(userInfo).length > 0 && !window.draw) {
  //     const Draw = new MapboxDraw({
  //       displayControlsDefault: false,
  //       controls: {
  //         polygon: true,
  //         point: true,
  //         trash: true,
  //       },
  //       // FIXME Custom styles of points and polygons MADE BY controls
  //       // for ref look in geo
  //       styles: userInfo.dark_theme ? customStylesDark : customStylesLight,
  //     });
  //
  //     window.draw = Draw;
  //
  //     const drawControls = new ExtendDrawBar({
  //       draw: Draw,
  //       buttons: [
  //         {
  //           on: 'click',
  //           action: deleteAll,
  //           classes: ['mapbox-gl-draw_ctrl-draw-btn', 'mapbox-gl-draw_trash'],
  //         },
  //       ],
  //     });
  //
  //     const { modes } = MapboxDraw;
  //     // modes.simple_select.onDrag = function (state, e) {};
  //
  //     if (window.map._controls.length != 3) {
  //       window.map.addControl(drawControls, 'bottom-left');
  //     }
  //
  //     window.addEventListener('keyup', (e) => {
  //       if (window.draw.getMode() !== 'simple_select' && e.key === 'Escape') {
  //         window.draw.changeMode('simple_select');
  //       }
  //     });
  //     window.map.on('draw.modechange', modeChangeHandler);
  //     window.map.on('draw.create', createObject);
  //     window.map.on('draw.delete', deleteAll);
  //     window.map.on('draw.update', updatePolygon);
  //   }
  // }, [userInfo, mapLoaded]);

  return <div ref={mapContainer} className="map-container" />;
}

export default Map;
